const getters = {
	device: (state) => state.app.device,
	accessToken: (state) => state.user.accessToken,
	userInfo: (state) => state.user.userInfo,
	hasLogin: (state) => state.user.hasLogin,
	DMS_CONFIG:(state) => state.user.DMS_CONFIG, // 站点信息
	dms:(state) => state.dms,// 挂在代理
};
export default getters;
